module.exports = __webpack_public_path__ + "static/media/carnage.b0d5ceae.svg";